// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const scyther: PokeData = {
  "id": 123,
  "name": "scyther",
  "height": 15,
  "weight": 560,
  "base_experience": 100,
  "types": [
    PokeType.BUG,
    PokeType.FLYING
  ],
  "api_moves": [
    "razor-wind",
    "swords-dance",
    "wing-attack",
    "leer",
    "agility",
    "quick-attack",
    "double-team",
    "focus-energy",
    "slash",
    "false-swipe",
    "fury-cutter",
    "pursuit",
    "silver-wind",
    "aerial-ace",
    "feint",
    "close-combat",
    "night-slash",
    "air-slash",
    "x-scissor",
    "vacuum-wave",
    "double-hit",
    "laser-focus"
  ],
  "moves": [
    "leer",
    "quick-attack",
    "pursuit",
    "aerial-ace",
    "close-combat",
    "night-slash",
    "air-slash",
    "vacuum-wave",
    "chatter",
    "bug-bite",
    "pin-missile",
    "acrobatics",
    "sticky-web"
  ],
  "evolution_chain": {
    "id": 58,
    "item": null,
    "species": [
      {
        "name": "scyther",
        "order": 141,
        "types": [
          PokeType.BUG,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "scizor",
        "order": 142,
        "types": [
          PokeType.BUG,
          PokeType.STEEL
        ],
        "evolves_from_species_id": 123,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      },
      {
        "name": "kleavor",
        "order": 900,
        "types": [
          PokeType.BUG,
          PokeType.ROCK
        ],
        "evolves_from_species_id": 123,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "black-augurite"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 75,
    "speed": 105,
    "ability_power": 110
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
